import { useSnackbar } from '@hue/design-system';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { getApiError, rootApi } from '../lib/api.js';
import { sessionQuery } from '../lib/session.js';

/// Sair é o pedido em que falhar calado é mais perigoso: a tela voltaria para a entrada com o
/// cookie ainda valendo no servidor, e quem largasse a máquina acharia que fechou o acesso. Por
/// isso a sessão local só é apagada depois que o servidor confirma, e a recusa é dita em voz alta.
///
/// Mora fora das duas cascas porque as duas têm o botão de sair, e a regra é uma só.
export function useLogout(): () => Promise<void> {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const snackbar = useSnackbar();

  return async () => {
    try {
      await rootApi.logout();
    } catch (error) {
      snackbar.failure(`${getApiError(error)} Sua conta continua aberta.`);
      return;
    }
    queryClient.setQueryData(sessionQuery.queryKey, null);
    await navigate({ to: '/login', replace: true });
  };
}
